import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';

interface ISection3Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[3],
    [settings?.paragraphs]
  );
  const quiz = paragraphSettings?.quiz;

  const handleQuizCompleted = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-core-section3-question');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="core-section">
      <div
        className="content-block topic-quiz"
        id="civil-core-section3-question"
      >
        <Quiz
          title={paragraphSettings?.questionTitle ?? ''}
          description={quiz?.description ?? ''}
          question={quiz?.question ?? ''}
          options={quiz?.options ?? []}
          onCompleted={handleQuizCompleted}
        />
      </div>
    </div>
  );
};

export default Section3;
